/* eslint-disable no-unused-vars */
import React from 'react';
import style from './search.module.scss';
import { selectImagesLimit, selectResourceByName } from 'store/page/pageSlice';
import { useContentAdapter } from 'hooks/useContentAdapter';
import includes from 'lodash-es/includes';
import { getTotal } from 'utils/utils';
import Pagination from 'components/pagination/pagination';
import cx from 'classnames';
import { PossibleAction, resourceSortTypes } from 'store/types';
import { useAppSelector } from 'store/hooks';
import GeneralSearch from 'controls/search/generalSearch/generalSearch';
import Sorting from 'components/sorting/sorting';
import { getCommonOmitActions } from 'utils/hooked';
import Grid2 from 'components/grid/grid2';
import SearchResult from 'components/searchResult/searchResult';
import { useResourceReRequest } from 'hooks/useResourceReRequest';

export default function Search() {
  const selector = selectResourceByName.bind(null, 'search');
  const resource = useAppSelector(selector);

  const omitedActions = getCommonOmitActions();
  const content = useContentAdapter(resource?.data || {}, {
    actions: (['edit', 'download', 'delete'] as PossibleAction[]).filter(
      (action: PossibleAction) => !includes(omitedActions, action)
    ),
  });
  useResourceReRequest(resource);
  const imagesLimit = useAppSelector(selectImagesLimit);

  const isResources = resource === undefined || resource?.total ? true : false;

  return (
    <>
      <div className={style.container}>
        <div className={cx(style.searchWrapper, 'adaptive-search__container')}>
          <GeneralSearch className={style.shadow}></GeneralSearch>
        </div>
        <SearchResult isResources={isResources}></SearchResult>

        {isResources ? (
          <>
            <Sorting
              items={resourceSortTypes}
              defaultSelectedValue={resourceSortTypes[6]}
              startURL={`/search?`}
            ></Sorting>
            <div className={style.grid}>
              <Grid2 images={content}></Grid2>
            </div>
          </>
        ) : (
          <span className={'notFoundBlock'}></span>
        )}
      </div>
      <Pagination
        className={'adaptive-search__pagination'}
        total={getTotal(resource, imagesLimit)}
      ></Pagination>
    </>
  );
}
